export const subtitles = {
    "1": {
        "startTime": 0.9420000000000001,
        "endTime": 4.455,
        "transcript": "Yaa, ciumek quyaviksugaaci taillerpeceńek.",
        "translation": "Yes, he first wants to thank you for coming."
    },
    "2": {
        "startTime": 5.583,
        "endTime": 10.567,
        "transcript": "Cali-llu at'minek, atranek apertuulluku.",
        "translation": "Also, I will say his name."
    },
    "3": {
        "startTime": 10.614,
        "endTime": 15.706,
        "transcript": "Fred Ollie-ruuq una wani. Maani wani elitnaurvigmi atanruuq.",
        "translation": "This is Fred Ollie. He's the principal of the school here."
    },
    "4": {
        "startTime": 17.34,
        "endTime": 22.806,
        "transcript": "Arcaqakluki ukut wani taqneret, imkut-llu ayagyuat Yugtun qantulit",
        "translation": "Especially for the adults and the young people who speak Yup'ik"
    },
    "5": {
        "startTime": 24.458,
        "endTime": 27.514,
        "transcript": "Taukut, taukunun-wa tunumalun' pillruuq.",
        "translation": "It was given to them."
    },
    "6": {
        "startTime": 27.52,
        "endTime": 31.694,
        "transcript": "Tua-i-llu-gguq waniw' tuacetun piyugyaaqluni man'a...",
        "translation": "And so, he said that he would want to do that with this..."
    },
    "7": {
        "startTime": 31.898,
        "endTime": 34.569,
        "transcript": "...rurtellriani arcaqakluci piyugyaaqluni piuq.",
        "translation": "... he wants to do it specifically for you."
    },
    "8": {
        "startTime": 37.465,
        "endTime": 45.585,
        "transcript": "Twelve years ago, I came to Alaska and went to the village of St. Mary's to begin teaching.",
        "translation": "Twelve years ago, I came to Alaska and went to the village of St. Mary's to begin teaching."
    },
    "9": {
        "startTime": 46.345,
        "endTime": 51.289,
        "transcript": "And needless to say, I didn't know much about Alaska.",
        "translation": "And needless to say, I didn't know much about Alaska."
    },
    "10": {
        "startTime": 51.454,
        "endTime": 54.028,
        "transcript": "I didn't know much about Western Alaska.",
        "translation": "I didn't know much about Western Alaska."
    },
    "11": {
        "startTime": 55.105,
        "endTime": 62.659,
        "transcript": "And I met, one of the first people I met was a nun, was a Catholic nun by the name of Sister Scholastica.",
        "translation": "And I met, one of the first people I met was a nun, was a Catholic nun by the name of Sister Scholastica."
    },
    "12": {
        "startTime": 63.024,
        "endTime": 66.57,
        "transcript": "And some of you in this room know Sister Scholastica.",
        "translation": "And some of you in this room know Sister Scholastica."
    },
    "13": {
        "startTime": 66.978,
        "endTime": 69.326,
        "transcript": "She's still doing the laundry at St. Mary's.",
        "translation": "She's still doing the laundry at St. Mary's."
    },
    "14": {
        "startTime": 70.742,
        "endTime": 75.408,
        "transcript": "And she gave me the best advice that anyone ever gave me.",
        "translation": "And she gave me the best advice that anyone ever gave me."
    },
    "15": {
        "startTime": 76.088,
        "endTime": 81.911,
        "transcript": "She said, \"You're new to Alaska. You don't know anything about these people.",
        "translation": "She said, \"You're new to Alaska. You don't know anything about these people."
    },
    "16": {
        "startTime": 82.913,
        "endTime": 90.278,
        "transcript": "\"So what I want you to do is to say very little and to listen, because there's a lot you need to learn.\"",
        "translation": "\"So what I want you to do is to say very little and to listen, because there's a lot you need to learn.\""
    },
    "17": {
        "startTime": 90.712,
        "endTime": 98.215,
        "transcript": "And it was very, very good advice, because even now, twelve years later, I still find that I do too much talking and not enough listening",
        "translation": "And it was very, very good advice, because even now, twelve years later, I still find that I do too much talking and not enough listening"
    },
    "18": {
        "startTime": 98.236,
        "endTime": 102.358,
        "transcript": "Because there's still a lot that the elders of this area can teach us.",
        "translation": "Because there's still a lot that the elders of this area can teach us."
    },
    "19": {
        "startTime": 106.492,
        "endTime": 108.454,
        "transcript": "Nun-at im' canek pilaqait?",
        "translation": "What do they call nuns again?"
    },
    "20": {
        "startTime": 111.352,
        "endTime": 117.222,
        "transcript": "Manassenkaamek-gguq tuani nallunrilkengangellruuq aterluni Sister Scholastica.",
        "translation": "He said that he came to know a nun by the name of Sister Scholastica."
    },
    "21": {
        "startTime": 118.547,
        "endTime": 128.095,
        "transcript": "When I was at St. Mary's, I met students from all over, all over the Yukon-Kuskokwim Delta in the coast.",
        "translation": "When I was at St. Mary's, I met students from all over, all over the Yukon-Kuskokwim Delta in the coast."
    },
    "22": {
        "startTime": 128.933,
        "endTime": 138.253,
        "transcript": "And in 1974, I had a class of students who I was particulary fond of.",
        "translation": "And in 1974, I had a class of students who I was particulary fond of."
    },
    "23": {
        "startTime": 138.837,
        "endTime": 142.532,
        "transcript": "And those are these students here.",
        "translation": "And those are these students here."
    },
    "24": {
        "startTime": 142.851,
        "endTime": 146.263,
        "transcript": "And I promised them when I left St. Mary's",
        "translation": "And I promised them when I left St. Mary's"
    },
    "25": {
        "startTime": 146.82,
        "endTime": 154.37,
        "transcript": "That no matter where I went, I would always keep a picture of that class in my office, and I always have.",
        "translation": "That no matter where I went, I would alwyas keep a picture of that class in my office, and I always have."
    },
    "26": {
        "startTime": 154.674,
        "endTime": 162.178,
        "transcript": "I lived in Juneau for a while, and I kept a picture of these students on my wall in Juneau. And now here in Bethel, I keep them on my wall.",
        "translation": "I lived in Juneau for a while, and I kept a picture of these students on my wall in Juneau. And now here in Bethel, I keep them on my wall."
    },
    "27": {
        "startTime": 162.879,
        "endTime": 170.543,
        "transcript": "And one of the reasons I do that, is because I look at these various individuals and I still keep in contact with them.",
        "translation": "And one of the reasons I do that, is because I look at these various individuals and I still keep in contact with them."
    },
    "28": {
        "startTime": 171.216,
        "endTime": 178.697,
        "transcript": "And it makes me realize how much things have changed in this area",
        "translation": "And it makes me realize how much things have changed in this area"
    },
    "29": {
        "startTime": 178.733,
        "endTime": 182.496,
        "transcript": "Because I can see the change in these students as they grow up.",
        "translation": "Because I can see the change in these students as they grow up."
    },
    "30": {
        "startTime": 187.985,
        "endTime": 194.382,
        "transcript": "Cali maavet tekicimi, calivimini-gguq maani qelkurluku.",
        "translation": "And when he came here, he said that he kept it in his office."
    },
    "31": {
        "startTime": 194.437,
        "endTime": 201.223,
        "transcript": "Waniwa una wani atularaa, tua-i-wa tangvalaamiki cat cimilriit.",
        "translation": "He uses this because he watches things changing."
    },
    "32": {
        "startTime": 201.371,
        "endTime": 205.806,
        "transcript": "Tangerrsugngaluki imumicetun ayuqenrilameng...",
        "translation": "He can see that they are not like before..."
    },
    "33": {
        "startTime": 206.562,
        "endTime": 209.074,
        "transcript": "Pass this around. Some people want to see it.",
        "translation": "Pass this around. Some people want to see it."
    },
    "34": {
        "startTime": 213.878,
        "endTime": 219.361,
        "transcript": "When I look at the pictures of those students, and I think about what they're doing now",
        "translation": "When I look at the pictures of those students, and I think about what they're doing now"
    },
    "35": {
        "startTime": 220.584,
        "endTime": 222.758,
        "transcript": "One thought comes to mind...",
        "translation": "One thought comes to mind..."
    },
    "36": {
        "startTime": 222.772,
        "endTime": 228.441,
        "transcript": "...being happy, living at home, or living somewhere else, but happy with themselves.",
        "translation": "...being happy, living at home, or living somewhere else, but happy with themselves."
    },
    "37": {
        "startTime": 228.561,
        "endTime": 236.81,
        "transcript": "Students who feel good about who they are are the students who did exactly what I think this conference is all about.",
        "translation": "Students who feel good about who they are are the students who did exactly what I think this conference is all about."
    },
    "38": {
        "startTime": 236.909,
        "endTime": 238.711,
        "transcript": "They're the students who took time...",
        "translation": "They're the students who took time..."
    },
    "39": {
        "startTime": 238.793,
        "endTime": 241.371,
        "transcript": "...people in their villages, and I really mean that.",
        "translation": "...people in their villages, and I really mean that."
    },
    "40": {
        "startTime": 241.926,
        "endTime": 246.113,
        "transcript": "When I look back, and I see the students again who are happy and successful...",
        "translation": "When I look back, and I see the students again who are happy and successful..."
    },
    "41": {
        "startTime": 246.16,
        "endTime": 252.514,
        "transcript": "...to learn from people who have lived a long time and have had many rich and wonderful experiences.",
        "translation": "...to learn from people who have lived a long time and have had many rich and wonderful experiences."
    },
    "42": {
        "startTime": 255.972,
        "endTime": 260.276,
        "transcript": "I want to conclude by again welcoming you to this week.",
        "translation": "I want to conclude by again welcoming you to this week."
    },
    "43": {
        "startTime": 260.87,
        "endTime": 264.455,
        "transcript": "I want to thank you for taking the time to be with us.",
        "translation": "I want to thank you for taking the time to be with us."
    },
    "44": {
        "startTime": 265.51,
        "endTime": 269.41,
        "transcript": "I'm very excited about it because this week, I get to be a student too.",
        "translation": "I'm very excited about it because this week, I get to be a student too."
    },
    "45": {
        "startTime": 269.99,
        "endTime": 277.118,
        "transcript": "I'm going to try to sit in on as many of the talks as possible so I can learn just along with everyone else.",
        "translation": "I'm going to try to sit in on as many of the talks as possible so I can learn just along with everyone else."
    },
    "46": {
        "startTime": 277.743,
        "endTime": 284.457,
        "transcript": "So once again, I want to thank you for coming to Bethel, for sharing your experiences with us.",
        "translation": "So once again, I want to thank you for coming to Bethel, for sharing your experiences with us."
    },
    "47": {
        "startTime": 284.814,
        "endTime": 290.662,
        "transcript": "And if there's anything I can do to make your stay happier and more enjoyable, please let me know.",
        "translation": "And if there's anything I can do to make your stay happier and more enjoyable, please let me know."
    },
    "48": {
        "startTime": 301.173,
        "endTime": 302.425,
        "transcript": "Quyanaqvaa.",
        "translation": "Thank you very much."
    },
    "49": {
        "startTime": 303.464,
        "endTime": 311.824,
        "transcript": "Uumi icivaq uum Nastashia-m qayagaullranga una qalrutkesqelluku",
        "translation": "Recently, when Nastashia called me to talk about this"
    },
    "50": {
        "startTime": 312.586,
        "endTime": 325.129,
        "transcript": "Qaillun-wa tua-i man'a yuuyaraq wall'u wangkuta piciryaraput ayagturallerkaa pitekluku qalarutesqelluci pillranga",
        "translation": "When she asked me to talk to you about how to continue our way of life or our culture"
    },
    "51": {
        "startTime": 326.338,
        "endTime": 328.057,
        "transcript": "Caperrsullruunga.",
        "translation": "I was daunted."
    },
    "52": {
        "startTime": 329.404,
        "endTime": 333.214,
        "transcript": "Cumigteng'e'rma capperrsullruunga.",
        "translation": "Though I was anxious, I was daunted."
    },
    "53": {
        "startTime": 334.678,
        "endTime": 336.327,
        "transcript": "Umyuarteqlua-wa waten:",
        "translation": "I was thinking like this:"
    },
    "54": {
        "startTime": 338.014,
        "endTime": 350.422,
        "transcript": "Wii ayagyuanruama una makunun ciuliamteńun aulukekaku assinrunayukluku umyuarteqellruunga.",
        "translation": "Since I am younger, I thought it would be better of our elders took care of it."
    },
    "55": {
        "startTime": 354.561,
        "endTime": 360.462,
        "transcript": "Tau͡gaam tayima piyunartacirramtun una caliaqeciqaqa",
        "translation": "I will work on this as best as I can"
    },
    "56": {
        "startTime": 361.313,
        "endTime": 364.329,
        "transcript": "Tau͡gaam cali ak'anun pivkenii.",
        "translation": "But I will not go for long."
    },
    "57": {
        "startTime": 365.818,
        "endTime": 374.933,
        "transcript": "Tayima icivaq nallunrituci elpeci ilaci tayima pikani Kassiglurmi quyurtellruut",
        "translation": "Some of you probably know that there was a meeting up in Kasigluk"
    },
    "58": {
        "startTime": 375.446,
        "endTime": 379.685,
        "transcript": "Ciuliaput-wa maani Kusquqvagmi Kuigpagmi-llu.",
        "translation": "Our elders from here on the Kuskokwim and the Yukon."
    },
    "59": {
        "startTime": 382.669,
        "endTime": 389.065,
        "transcript": "Tuantellrunritua. Pitsaqevkenii-wa tua-i tuantellrunritua.",
        "translation": "I wasn't there. I was not deliberately absent."
    },
    "60": {
        "startTime": 389.082,
        "endTime": 398.008,
        "transcript": "Tuancuumillruyaaqua tau͡gaam tayima iliini caliarkat umyuaq aturluku piksailata tuantellrunritua.",
        "translation": "I wanted to be there, but since we are not always free from work, I wasn't there."
    },
    "61": {
        "startTime": 399.272,
        "endTime": 403.272,
        "transcript": "Qanrucimallruunga tau͡gaam tuani quyurtellerpeceńi",
        "translation": "But I was told that when you held the meeting there"
    },
    "62": {
        "startTime": 404.016,
        "endTime": 417.065,
        "transcript": "Qaillun-wa tua-i mat'um yuucimta ayuqucia, ayuqucianek tua-i-w' taun' caliaqellrulliniarci.",
        "translation": "That you worked on what our way of life is like."
    },
    "63": {
        "startTime": 422.908,
        "endTime": 429.534,
        "transcript": "For the benefit of those of you who have some limited understanding of the English language, let me paraphrase the main points.",
        "translation": "For the benefit of those of you who have some limited understanding of the English language, let me paraphrase the main points."
    },
    "64": {
        "startTime": 430.824,
        "endTime": 439.633,
        "transcript": "Very recently, when Nastashia Martin called me to speak on the issue of how you could continue with the Yup'ik language",
        "translation": "Very recently, when Nastashia Martin called me to speak on the issue of how you could continue with the Yup'ik language"
    },
    "65": {
        "startTime": 439.694,
        "endTime": 441.8,
        "transcript": "I'm sorry, Yup'ik values",
        "translation": "I'm sorry, Yup'ik values"
    },
    "66": {
        "startTime": 442.978,
        "endTime": 448.928,
        "transcript": "Although I was enthusiastic about it, I also had some reservations",
        "translation": "Although I was enthusiastic about it, I also had some reservations"
    },
    "67": {
        "startTime": 448.943,
        "endTime": 456.808,
        "transcript": "Primarily because of the fact that I feel that it's an issue that can best be addressed by our elders.",
        "translation": "Primarily because of the fact that I feel that it's an issue that can best be addressed by our elders."
    },
    "68": {
        "startTime": 458.538,
        "endTime": 463.907,
        "transcript": "I am young, and because I am young, I feel that I have a lot to learn.",
        "translation": "I am young, and because I am young, I feel that I have a lot to learn."
    },
    "69": {
        "startTime": 465.758,
        "endTime": 472.886,
        "transcript": "But I'm going to try my best under the circumstances.",
        "translation": "But I'm going to try my best under the circumstances."
    },
    "70": {
        "startTime": 473.808,
        "endTime": 482.326,
        "transcript": "Very recently, there was a conference at Kassigluq where the elders of the Yukon-Kuskokwim Delta were the prime people who attended the conference.",
        "translation": "Very recently, there was a conference at Kasigluk where the elders of the Yukon-Kuskokwim Delta were the prime people who attended the conference."
    },
    "71": {
        "startTime": 483.786,
        "endTime": 487.176,
        "transcript": "Although I did not have the privilege of attending this conference",
        "translation": "Although I did not have the privilege of attending this conference"
    },
    "72": {
        "startTime": 487.304,
        "endTime": 493.382,
        "transcript": "I understand that the main focus of the conference dealt with the issue of preserving our way of life.",
        "translation": "I understand that the main focus of the conference dealt with the issue of preserving our way of life."
    },
    "73": {
        "startTime": 493.645,
        "endTime": 500.248,
        "transcript": "I would like to have been there, however, circumstances sometimes relating with job prevents that.",
        "translation": "I would like to have been there, however, circumstances sometimes relating with jobs prevents that."
    },
    "74": {
        "startTime": 502.531,
        "endTime": 507.964,
        "transcript": "Tua-llu ava-i qanqallruunga una qalrutkarkaqa",
        "translation": "And so, I just mentioned what I would talk about"
    },
    "75": {
        "startTime": 509.013,
        "endTime": 515.418,
        "transcript": "Elluatuunruluku makunun taqnemteńun auluknayukluku pillruyaaqua.",
        "translation": "I had thought that our adults would be better suited to cover it."
    },
    "76": {
        "startTime": 518.943,
        "endTime": 524.645,
        "transcript": "Ukut-wa tegganemta tayima ayuqucirtualaraakut",
        "translation": "Our elders here instruct us"
    },
    "77": {
        "startTime": 525.666,
        "endTime": 528.212,
        "transcript": "CIunerkaput-llu nasvagaqluku.",
        "translation": "And they show us what's in store for us."
    },
    "78": {
        "startTime": 532.474,
        "endTime": 539.014,
        "transcript": "Nallunrilameng-wa qaillun ciunerkaput ayuqucia yuullruameng.",
        "translation": "It's because they know what's in store for us since they've lived."
    },
    "79": {
        "startTime": 542.644,
        "endTime": 544.581,
        "transcript": "Atam yuvriqaqernaurput.",
        "translation": "Look, let us examine it."
    },
    "80": {
        "startTime": 546.113,
        "endTime": 553.141,
        "transcript": "Kass'atun elitnaurpailemta ukut ciuliamta tangellruat.",
        "translation": "Before we started having school in English, our elders saw it."
    },
    "81": {
        "startTime": 553.155,
        "endTime": 560.524,
        "transcript": "Tayima nallunaituq waten Kass'atun piurangllerkarput.",
        "translation": "It's clear that we will start speaking only in English."
    },
    "82": {
        "startTime": 564.914,
        "endTime": 572.269,
        "transcript": "Tayima, tayima ilavci nallrunritaa, nallunritliarci-wa imna Qinarmiulleq Pavila.",
        "translation": "Some of you probably know Pavila who was from Qinaq."
    },
    "83": {
        "startTime": 573.312,
        "endTime": 574.425,
        "transcript": "Apa'urluqa.",
        "translation": "My grandfather."
    },
    "84": {
        "startTime": 578.425,
        "endTime": 581.078,
        "transcript": "Taum qanrut'lallruanga waten:",
        "translation": "He would tell me this:"
    },
    "85": {
        "startTime": 582.694,
        "endTime": 591.276,
        "transcript": "Ayagyuallermini-gguq pektaqami ikamrakun iliini pitsaqa'artevkenani Kass'agnek malrugnek tanglartuq.",
        "translation": "He said that when he traveled with a sled when he was young, he would come by two Caucasians by chance."
    },
    "86": {
        "startTime": 594.602,
        "endTime": 597.382,
        "transcript": "Tua-llu pivakarluni pianga",
        "translation": "And the one day, he said to me"
    },
    "87": {
        "startTime": 599.382,
        "endTime": 606.921,
        "transcript": "Tau͡gken maa-i iliini nunami-llu ataucimi malruunaurtuk Kass'ak.",
        "translation": "Yet sometimes now, there would be two Caucasians in one village."
    },
    "88": {
        "startTime": 607.737,
        "endTime": 612.305,
        "transcript": "Maa-i taum date-aa tayim' late 1950's.",
        "translation": "Now, the date of that is around the late 1950's."
    },
    "89": {
        "startTime": 615.602,
        "endTime": 622.155,
        "transcript": "Waten qanqallruuq: \"Amlleriinartut alungutiit.",
        "translation": "He mentioned this: \"Their tongues are increasing."
    },
    "90": {
        "startTime": 622.801,
        "endTime": 628.155,
        "transcript": "\"Qaneryarait-llu eliskuvki maa-i assinruciqsugnarquq.\"",
        "translation": "\"And it would probably be better if you learned their languages.\""
    },
    "91": {
        "startTime": 630.411,
        "endTime": 635.035,
        "transcript": "Umyuartutacia, Kass'atun tau͡gken qanyuunani.",
        "translation": "That's his wisdom, though he never spoke English."
    },
    "92": {
        "startTime": 639.871,
        "endTime": 650.604,
        "transcript": "Ciuliamta umyuartutacia, umyuartutaciteng-llu tuaggun apa'urlumkun pugellruuq.",
        "translation": "The wisdom of our ancestors appeared like that through my grandfather."
    },
    "93": {
        "startTime": 655.732,
        "endTime": 660.228,
        "transcript": "Taum nalliini camek qalarucia taringumallrunritaqa, camek-llu picia.",
        "translation": "At that time, I didn't understand what he was saying, nor what he meant."
    },
    "94": {
        "startTime": 661.358,
        "endTime": 669.709,
        "transcript": "Tau͡gken maa-i caliurangllemkun murilkurangua qanellra picia piciupiallinilria.",
        "translation": "Yet now, as I've started working and observing, it turns out that what he said was absolutely true."
    },
    "95": {
        "startTime": 672.351,
        "endTime": 682.221,
        "transcript": "I somehow feel that the main speaker this morning on this subject, how you could continue with Yup'ik values, should be one of the elders",
        "translation": "I somehow feel that the main speaker this morning on this subject, how you could continue with Yup'ik values, should be one of the elders"
    },
    "96": {
        "startTime": 683.58,
        "endTime": 693.626,
        "transcript": "Because in my opinion, they are the real people who should be giving us this guidance on the issue.",
        "translation": "Because in my opinion, they are the real people who should be giving us this guidance on the issue."
    },
    "97": {
        "startTime": 694.564,
        "endTime": 703.129,
        "transcript": "It is them who have given us guidance so that what is left of our values can be preserved.",
        "translation": "It is them who have given us guidance so that what is left of our values can be preserved."
    },
    "98": {
        "startTime": 705.511,
        "endTime": 709.999,
        "transcript": "It is them who had the wisdom to push for a Western type of education",
        "translation": "It is them who had the wisdom to push for a Western type of education"
    },
    "99": {
        "startTime": 710.564,
        "endTime": 715.846,
        "transcript": "So that we could be able to at least see and hopefully understand what is happening today.",
        "translation": "So that we could be able to at least see and hopefully understand what is happening today."
    },
    "100": {
        "startTime": 716.716,
        "endTime": 731.062,
        "transcript": "For example, my grandfather Pavila who is from Qinaq was telling me that in his youth, when he was traveling throughout the region with a sled",
        "translation": "For example, my grandfather Pavila who is from Qinaq was telling me that in his youth, when he was traveling throughout the region with a sled"
    },
    "101": {
        "startTime": 731.404,
        "endTime": 735.877,
        "transcript": "That sometimes, he saw more than one white man in the whole region.",
        "translation": "That sometimes, he saw more than one white man in the whole region."
    },
    "102": {
        "startTime": 738.961,
        "endTime": 749.129,
        "transcript": "He said, however, in the late 1950's, he said there are more and more of them in the region.",
        "translation": "He said, however, in the late 1950's, he said there are more and more of them in the region."
    },
    "103": {
        "startTime": 749.338,
        "endTime": 753.835,
        "transcript": "And sometimes, there are even more than one white person in a village.",
        "translation": "And sometimes, there are even more than one white person in a village."
    },
    "104": {
        "startTime": 757.479,
        "endTime": 764.379,
        "transcript": "He said at the time that you should learn their tongue, you should learn their language",
        "translation": "He said at the time that you should learn their tongue, you should learn their language"
    },
    "105": {
        "startTime": 765.356,
        "endTime": 769.684,
        "transcript": "So that you could at least understand what is it that you want.",
        "translation": "So that you could at least understand what is it that you want."
    },
    "106": {
        "startTime": 773.806,
        "endTime": 779.192,
        "transcript": "It was through him that the wisdom of our elders was brought forth.",
        "translation": "It was through him that the wisdom of our elders was brought forth."
    },
    "107": {
        "startTime": 782.379,
        "endTime": 789.128,
        "transcript": "He saw much in advance, what was going to happen today.",
        "translation": "He saw much in advance, what was going to happen today."
    },
    "108": {
        "startTime": 790.672,
        "endTime": 797.748,
        "transcript": "I'm very thankful that through his wisdom that they pushed us for education.",
        "translation": "I'm very thankful that through his wisdom that they pushed us for education."
    },
    "109": {
        "startTime": 801.637,
        "endTime": 802.316,
        "transcript": "Tua-llu.",
        "translation": "Going forward."
    },
    "110": {
        "startTime": 805.128,
        "endTime": 807.584,
        "transcript": "Caliarkamnun piqaqernaurtukut.",
        "translation": "Let's go over my work."
    },
    "111": {
        "startTime": 809.21,
        "endTime": 816.087,
        "transcript": "Qaillun ayagturallerkaa Yupiit piciryarait.",
        "translation": "How Yup'ik culture will continue."
    },
    "112": {
        "startTime": 819.443,
        "endTime": 829.247,
        "transcript": "Nallunrituci maa-i-rpak wani Calista Corporation-aami nunaliurteńguunga",
        "translation": "You know that I work with land at Calista Corporation"
    },
    "113": {
        "startTime": 829.41,
        "endTime": 833.524,
        "transcript": "Nuna-llu qaillun auluklerkaa caliaqaqluku.",
        "translation": "And I work with how to take care of the land."
    },
    "114": {
        "startTime": 836.345,
        "endTime": 843.443,
        "transcript": "Nunam auluklerkaa aulukqainaqumteggu cakviurnarqenricaaquq",
        "translation": "It is not difficult to merely take care of the land"
    },
    "115": {
        "startTime": 845.706,
        "endTime": 856.132,
        "transcript": "Tau͡gaam cakviurnarilartuq wangkuta piciryaraput-llu Kass'at-llu piciryarait atauciurtengnaqluki aulukaqamteggu.",
        "translation": "But it gets difficult when we try to combine our ways and Western ways to take care of it."
    },
    "116": {
        "startTime": 858.624,
        "endTime": 869.247,
        "transcript": "Ciuliaput, wangkuta-llu, kinguliaput-llu kingunengqertut nunamek.",
        "translation": "Our ancestors, we, and our descendants originate from the land."
    },
    "117": {
        "startTime": 873.836,
        "endTime": 881.803,
        "transcript": "Ciuliamta man'a nuna atulallruat.",
        "translation": "Our ancestors utilized this land."
    },
    "118": {
        "startTime": 883.935,
        "endTime": 892.0,
        "transcript": "Atam ellamun an'aqamta wall'u maa-i aneryaarturalartut aipamta apqiitnek air.",
        "translation": "You see, when we go outside, or we breathe what our counterparts call air."
    },
    "119": {
        "startTime": 892.705,
        "endTime": 896.23,
        "transcript": "Tua-i-ll' tamatutailkan epciqukut.",
        "translation": "And if we don't have that, we will suffocate."
    },
    "120": {
        "startTime": 903.64,
        "endTime": 911.411,
        "transcript": "Man'a nuna yumta atutua yuutekluku, yuutekqapiarluki.",
        "translation": "Our people utilize this land for survival, for absolute survival."
    },
    "121": {
        "startTime": 914.853,
        "endTime": 923.672,
        "transcript": "Nunamek pitarkanek pissutuukut, estuulumun-llu pitaput elliaqluki ner'aqluki.",
        "translation": "We hunt animals from the land, then put our catch on the table and eat them."
    },
    "122": {
        "startTime": 923.886,
        "endTime": 941.246,
        "transcript": "Tuamta-llu pissuraqamta pitamta iliini amiit tayima atutullruaput aturaurrluki, piluguurrluki, wall'u pilugullraurrluki.",
        "translation": "And then sometimes when we hunt, we would use sometimes use the hide to make clothes, make skin boots, or those old skin boots."
    },
    "123": {
        "startTime": 944.541,
        "endTime": 953.328,
        "transcript": "Tamakunek qanqertua waten umyuarteqlua: nuna man'a unguvatkarput.",
        "translation": "I'm talking about those with this in mind: this land keeps us alive."
    },
    "124": {
        "startTime": 958.64,
        "endTime": 966.722,
        "transcript": "Tuamta-llu imarpiim, imarpiim cain unguvacetuakut.",
        "translation": "And then, the things from the ocean keep us alive."
    },
    "125": {
        "startTime": 970.885,
        "endTime": 979.279,
        "transcript": "Tayima mat'um nunam camek cikiraqakut piliaqesteput aturluku quyalalta",
        "translation": "When this land gives us anything through our creator, let us be thankful"
    },
    "126": {
        "startTime": 982.197,
        "endTime": 984.886,
        "transcript": "Ellmikutuaraurtellriatun-llu piaqluta.",
        "translation": "And be humble."
    },
    "127": {
        "startTime": 988.623,
        "endTime": 995.672,
        "transcript": "Unakek'ngaput-llu tayima ilaput ikayuraqluki pikumteki assiryaryugnarquq.",
        "translation": "And I think it would be good if we help those around us through what we get."
    },
    "128": {
        "startTime": 998.296,
        "endTime": 1008.28,
        "transcript": "As most of you may know, one of my major responsibilities with Calista Corporation is to run and manage Land and Natural Resources Department.",
        "translation": "As most of you may know, one of my major responsibilities with Calista Corporation is to run and manage Land and Natural Resources Department."
    },
    "129": {
        "startTime": 1009.361,
        "endTime": 1015.197,
        "transcript": "Land management in and of itself is not difficult.",
        "translation": "Land management in and of itself is not difficult."
    },
    "130": {
        "startTime": 1017.754,
        "endTime": 1026.869,
        "transcript": "But if one were to look at land management strictly from standpoint of Western land management",
        "translation": "But if one were to look at land management strictly from the standpoint of Western land management"
    },
    "131": {
        "startTime": 1027.525,
        "endTime": 1042.935,
        "transcript": "However, it gets difficult when one begins to look at land from standpoint of Yup'ik values and trying to put Western values into it.",
        "translation": "However, it gets difficult when one begins to look at land from the standpoint of Yup'ik values and trying to put Western values into it."
    },
    "132": {
        "startTime": 1045.673,
        "endTime": 1051.952,
        "transcript": "The very basis of our society is land, the Yup'ik society.",
        "translation": "The very basis of our society is land, the Yup'ik society."
    },
    "133": {
        "startTime": 1053.493,
        "endTime": 1060.919,
        "transcript": "Our ancestors looked at land much the same way that we look at air we breathe today.",
        "translation": "Our ancestors looked at land much the same way that we look at the air we breathe today."
    },
    "134": {
        "startTime": 1062.44,
        "endTime": 1066.187,
        "transcript": "We need air to breathe so that we may survive.",
        "translation": "We need air to breathe so that we may survive."
    },
    "135": {
        "startTime": 1069.121,
        "endTime": 1076.429,
        "transcript": "In the beginning, and even today, the Yup'ik people has always been land users.",
        "translation": "In the beginning, and even today, the Yup'ik people have always been land users."
    },
    "136": {
        "startTime": 1080.517,
        "endTime": 1084.088,
        "transcript": "We survived with the land and what the land provided us.",
        "translation": "We survived with the land and what the land provided us."
    },
    "137": {
        "startTime": 1086.374,
        "endTime": 1088.473,
        "transcript": "Land provided us with clothing.",
        "translation": "Land provided us with clothing."
    },
    "138": {
        "startTime": 1090.736,
        "endTime": 1101.274,
        "transcript": "We needed to dress ourselves so that we can protect, we can be protected from any kind of weather.",
        "translation": "We needed to dress ourselves so that we can protect, we can be protected from any kind of weather."
    },
    "139": {
        "startTime": 1104.209,
        "endTime": 1109.407,
        "transcript": "Sea also provided us with clothing and food.",
        "translation": "The sea also provided us with clothing and food."
    },
    "140": {
        "startTime": 1111.978,
        "endTime": 1123.297,
        "transcript": "My point here being: land is something our society has needed and will probably need for long time to come to survive.",
        "translation": "My point here being: land is something our society has needed and will probably need for a long time to come to survive."
    },
    "141": {
        "startTime": 1125.505,
        "endTime": 1135.56,
        "transcript": "What it has provided us, we must receive thankfully, humbly, and we must share that wealth with others.",
        "translation": "What it has provided us, we must receive thankfully, humbly, and we must share that wealth with others."
    },
    "142": {
        "startTime": 1140.77,
        "endTime": 1141.66,
        "transcript": "Tua-llu.",
        "translation": "Continuing on."
    },
    "143": {
        "startTime": 1145.264,
        "endTime": 1152.209,
        "transcript": "Qaillun-mi man'a yuuyararput, yuuyaramta-llu piciryaraa ayagturciqa?",
        "translation": "But how will our way of life and our culture continue?"
    },
    "144": {
        "startTime": 1155.604,
        "endTime": 1164.033,
        "transcript": "Qanrucimalartukut, \"Kitaki cumiggluten elitnaura.\"",
        "translation": "We are told, \"Please focus when you're in school.\""
    },
    "145": {
        "startTime": 1167.869,
        "endTime": 1175.286,
        "transcript": "Tua-ll' tuaten ellimeruqaamta wall'u qanrucimaaqamta, \"Cumiggluten elitnaura,\" caularta?",
        "translation": "And then when we are requested or told that, \"Focus when you're in school,\" what does it mean?"
    },
    "146": {
        "startTime": 1178.33,
        "endTime": 1181.879,
        "transcript": "Tuamta-llu kia elitnaurciqakut?",
        "translation": "And then who will teach us?"
    },
    "147": {
        "startTime": 1186.188,
        "endTime": 1195.495,
        "transcript": "Kitaki wangkutnek ap'arteqernaurtukut, \"Kia elitnaurciqakut?\"",
        "translation": "Now, let us ask ourselves, \"Who will teach us?\""
    },
    "148": {
        "startTime": 1196.517,
        "endTime": 1204.979,
        "transcript": "Atam takuyaqaqerci, caniqlici-llu tangerrluki, wall'u kiarteqaqerci maani.",
        "translation": "Now look behind you, and look at those next to you, or look around here."
    },
    "149": {
        "startTime": 1206.286,
        "endTime": 1211.297,
        "transcript": "Elitnauristekaput aqumgaurtut waniwa.",
        "translation": "Those who will teach us are sitting here."
    },
    "150": {
        "startTime": 1218.692,
        "endTime": 1228.736,
        "transcript": "Ellaita-wa yuullruameng qaillun yuuyaramek ellaita qanruskakut, ciuliamta makut",
        "translation": "Since they have lived, if they, our elders here, talk to us about our way of life"
    },
    "151": {
        "startTime": 1230.77,
        "endTime": 1238.176,
        "transcript": "Maligeskumteki tayima cam iliini cakviussiyaaksaunata yuuciqsugnarqukut.",
        "translation": "If we obey them, we may one day live with little hardship."
    },
    "152": {
        "startTime": 1246.593,
        "endTime": 1247.451,
        "transcript": "Kitaki.",
        "translation": "Let's do it."
    },
    "153": {
        "startTime": 1248.44,
        "endTime": 1251.396,
        "transcript": "Ciuliamta camek qanruartaqatkut",
        "translation": "When our elders speak to us about something"
    },
    "154": {
        "startTime": 1252.956,
        "endTime": 1257.044,
        "transcript": "Quyanarqelartuq-llu ayuqucirtuagaqatkut",
        "translation": "And we are thankful when they instruct us"
    },
    "155": {
        "startTime": 1258.132,
        "endTime": 1259.528,
        "transcript": "Niicugnilalta.",
        "translation": "Let us listen."
    },
    "156": {
        "startTime": 1260.319,
        "endTime": 1269.649,
        "transcript": "Niicugniqainarpek'nata-llu qanellrita iliit maliga'rtaqluta pikumta cakviussiyaagluta pingaicugnarqukut.",
        "translation": "And if we don't stop at listening, but obey some of what they say, we probably will not have much difficult times."
    },
    "157": {
        "startTime": 1272.231,
        "endTime": 1274.33,
        "transcript": "Just who is to be our teacher?",
        "translation": "Just who is to be our teacher?"
    }
};